module.exports = __webpack_public_path__ + "static/media/office-new-york.616dcdd7.png";